import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20scene%20of%20carefully%20packaged%20boxes%20with%20shipping%20labels%20stacked%20on%20a%20wooden%20table%20near%20a%20sunlit%20window%2C%20soft%20golden%20hour%20light%20streaming%20in%2C%20few%20fashion%20items%20peeking%20from%20an%20open%20package%2C%20cozy%20warehouse%20aesthetic%2C%20warm%20amber%20and%20cream%20tones%2C%20lifestyle%20logistics%20photography&width=1920&height=800&seq=cta-pano-v2-c2d3&orientation=landscape"
          alt="CSSBuy Logística e envio"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 md:px-12 py-20">
        <div className="relative min-h-[400px] md:min-h-[480px]">
          <h2 className="absolute top-12 left-0 md:left-8 font-heading text-5xl md:text-7xl lg:text-8xl text-white font-bold lowercase leading-none max-w-2xl drop-shadow-lg">
            {t('cta.heading')}
          </h2>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="absolute bottom-8 left-0 md:left-8 flex items-center gap-3 px-6 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-all duration-200 whitespace-nowrap shadow-lg"
          >
            {t('cta.button')}
            <span className="w-[30px] h-[30px] rounded-full bg-foreground-900 flex items-center justify-center">
              <i className="ri-arrow-right-line text-white text-xs"></i>
            </span>
          </a>

          <div className="absolute bottom-12 right-0 md:right-8 text-right">
            <p className="text-white/70 text-sm md:text-base leading-relaxed drop-shadow-sm">
              {t('cta.disclaimer_line1')}
              <br />
              {t('cta.disclaimer_line2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}